import React, { ReactElement } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import { useAppContext } from '../../../components/appContext/AppContext';
import { RESET_PASSWORD_PAGE, EXPIRED_PASSWORD_PAGE } from '../../../common/routes';
import ResetPasswordPage from './ResetPasswordPage';
import ChangePasswordPage from '../../changePassword/ChangePasswordPage';

export interface ParamTypes {
    username: string;
    token: string;
}

const ResetPasswordRouter: React.FunctionComponent = (): ReactElement | null => {
    const { username } = useParams<ParamTypes>();
    const { token } = useParams<ParamTypes>();
    const { configState } = useAppContext();

    return (
        <Switch>
            <Route
                path={RESET_PASSWORD_PAGE}
                render={(): ReactElement => (
                    <ResetPasswordPage
                        username={username}
                        token={token}
                        resumeUrl={`${configState.config.pingAccessUrl.split('?')[0]}`}
                    />
                )}
            />
            <Route
                path={EXPIRED_PASSWORD_PAGE}
                render={(): ReactElement => (
                    <ChangePasswordPage
                        username={username}
                        resumeUrl={`${configState.config.pingAccessUrl}`}
                        resumeButtonText={`Sign in`}
                        title={'Your password has expired'}
                        instructionText={
                            'For your security, we ask that you change your password every 3 months. Please create a new secure password to Sign in going forward.'
                        }
                    />
                )}
            />
        </Switch>
    );
};

export default ResetPasswordRouter;
